import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import ButtonTemplate from './ButtonTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

export default class ButtonComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.BUTTON)

    this.data.component = ButtonTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder(node) {
    node.lingualName = lingualName.BUTTON
    this.setConnection()

    const buttonInput = new Rete.Input(CONST_SOCKET.BUTTON_INPUT, lang.button_socket_input_reply, this.socket.buttonInput, true)
    const buttonOutput = new Rete.Output(CONST_SOCKET.BUTTON_OUTPUT, lang.button_socket_output_next, this.socket.buttonOutput, false)

    return node
      .addInput(buttonInput)
      .addOutput(buttonOutput)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.BUTTON_OUTPUT] = node.data
  }
  
  setConnection() {
    // Button may take connections from:
    this.socket.buttonInput.combineWith(this.socket.textOutputButton)
    this.socket.buttonInput.combineWith(this.socket.carouselItemOutputButton)
    this.socket.buttonInput.combineWith(this.socket.facebookMediaOutputButton)
    this.socket.buttonInput.combineWith(this.socket.genericTemplateOutputButton)

    // Button may be connected to:
    this.socket.buttonOutput.combineWith(this.socket.newPostbackInput)
    this.socket.buttonOutput.combineWith(this.socket.referenceInput)
    this.socket.buttonOutput.combineWith(this.socket.newPostbackInputTrigger)
    this.socket.buttonOutput.combineWith(this.socket.componentListInput)
    
    if (this.isUserInputFlowAddonAvailable) {
      this.socket.buttonOutput.combineWith(this.socket.userInputFlowInput)    
    }
  }
}